export enum RolePermission {
    READ = 'read',
    WRITE = 'write',
    EDIT = 'edit',
    DELETE = 'delete'
}